/* eslint-disable */
import jQuery from 'jquery';
export default class BetAndLoginToWatchCourseList {
    constructor() {
        const defaultConfig = {
            selectors: {
                accordion             : '.js-accordion',
                accordionRow          : '.js-accordion__row',
                accordBetToViewMsg    : '.js-accordion__content .RC-accordion__content__messageBetToView',
                accordLoggedOutMsg    : '.js-accordion__content .RC-accordion__content__messageLoggedOutWatch',
                accordLoggedInMsg     : '.js-accordion__content .RC-accordion__content__messageLoggedInWatch',
                nodeMeetingList       : '.ui-accordion__content .RC-meetingList .RC-meetingItem',
                meetingItemLink       : '.RC-meetingItem__link',
                meetingItemLinkIcon   : '.RC-meetingItem__link .RC-meetingItem__icon',
            },
            byTime:{
                meetingsByTime        : '.RC-controlPanel .RC-switcher__wrapper .ui-switcher__btnByTime.ui-btn_primary',
                meetingGroup          : '.RC-meetingList_byTime',
                nodeMeetingList       : '.RC-meetingItem',
                meetingItemLink       : '.RC-meetingItem__link',
                meetingItemLinkIcon   : '.RC-meetingItem__link .RC-meetingItem__icon',
            },
            classes: {
                iconWrap          : '.RC-meetingItem__icon',
                defaultVideoIcon  : '.RC-watchLiveIcon__default',
                redVideoIcon      : '.RC-watchLiveIcon__redVideo',
                bigPlayIcon       : '.RC-watchLiveIcon__bigRedPlay',
            },
        };

        this.config = jQuery.extend(true, defaultConfig, BetAndLoginToWatchCourseList);
        const initCheck = this.isAccordion() || this.isRacesByTime();

        if (!initCheck) return;

        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        document.addEventListener("BETSLIP.BOOKMAKER.LOGGED_IN", () => {
            this.initCourseListCheck(
                this.isAccordion(),
                this.isRacesByTime(),
                true
            );
        });

        document.addEventListener("BETSLIP.BOOKMAKER.LOGGED_OUT", () => {
            this.initCourseListCheck(
                this.isAccordion(),
                this.isRacesByTime()
            );
        });

        this.initCourseListCheck(this.isAccordion(), this.isRacesByTime());
        setInterval(() =>{
            this.initCourseListCheck(this.isAccordion(), this.isAccordion());
        }, 60000);
    }

    initCourseListCheck(checkAccordion, checkRacesByTime, eventLogin = false){
        const isLoggedIn = eventLogin === true ? eventLogin : this.isLoggedIn();

        if(checkAccordion){
          this.$courseList = document.querySelector(this.config.selectors.accordion);
          this.initUpdateCourseView(this.$courseList, isLoggedIn);

        } else if(checkRacesByTime){
          this.$courseList = document.querySelector(this.config.byTime.meetingGroup);
          this.changeBetToViewMeetingsList(this.$courseList, "byTime", isLoggedIn);
        }
    }

    isAccordion(){
        return document.querySelector(this.config.selectors.accordion) !== null;
    }

    isRacesByTime(){
        return document.querySelector(this.config.byTime.meetingsByTime) !== null;
    }

    initUpdateCourseView(courseList, isLoggedIn){
      if(courseList.querySelectorAll(this.config.selectors.accordionRow) == null) return;
      const courses = courseList.querySelectorAll(this.config.selectors.accordionRow);

      courses.forEach((course) => {
          const BetToViewMsg = course.querySelector(this.config.selectors.accordBetToViewMsg);
          const LoggedOutMsg = course.querySelector(this.config.selectors.accordLoggedOutMsg);
          const LoggedInMsg = course.querySelector(this.config.selectors.accordLoggedInMsg);

          if(!BetToViewMsg) return;
          if(!LoggedOutMsg) return;
          if(!LoggedInMsg) return;

          const isBetToView = course.dataset.bettoview == "1";

          LoggedOutMsg
              .querySelector(".RC-accordion__content__message__wrap")
              .addEventListener(
                  "click", ()=>{
                      window.location.href = '/my-bookmakers/';
                  }
              );

          LoggedOutMsg.style.display = !isLoggedIn ? "block" : "none";
          LoggedInMsg.style.display = !isLoggedIn ? "none" : "block";

          if(isBetToView){
              BetToViewMsg.style.display = "block";
              LoggedInMsg.style.display = "none";
              LoggedOutMsg.style.display = "none";
          } else if(isLoggedIn){
              LoggedInMsg.style.display = "block";
              LoggedOutMsg.style.display = "none";
          }

          this.changeBetToViewMeetingsList(course, "selectors", isLoggedIn);
      });
    }

    changeBetToViewMeetingsList(course, configName, isLoggedIn){
        const meetingList = course.querySelectorAll(this.config[configName].nodeMeetingList);

        if(!meetingList)  return;
        
        meetingList.forEach((race) => {
            const courseItem = race.querySelector(this.config[configName].meetingItemLink);
            const raceIcons  = race.querySelector(this.config[configName].meetingItemLinkIcon);

            if(!courseItem) return;
            if(!raceIcons) return;

            const defaultVideoIcon = raceIcons.querySelector(this.config.classes.defaultVideoIcon);
            const redVideoIcon = raceIcons.querySelector(this.config.classes.redVideoIcon);
            const bigPlayIcon = raceIcons.querySelector(this.config.classes.bigPlayIcon);
            const isBetToView = courseItem.dataset.bettoview == "1";
            const isLoginToView = courseItem.dataset.bettoview == "0" && courseItem.dataset.paidlivestream == "1" ;
            const isFreeLivestream = courseItem.dataset.freelivestream == "1" ;

            if(isBetToView){
                this.setDefaultVideoIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon);

                if(this.isQualified(courseItem.dataset.raceId)){
                    this.setRedVideoIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon);

                    if(this.isLivestreamActive(courseItem.dataset.raceDate)){
                       this.setRedPlayIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon)
                    }
                }
            } else if(isFreeLivestream || isLoginToView && isLoggedIn){
                this.setRedVideoIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon);
            
                if(this.isLivestreamActive(courseItem.dataset.raceDate)){
                    this.setRedPlayIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon);
                }
            }
            
            if(!isLoggedIn && !isBetToView){
                this.setDefaultVideoIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon);
            }

            if(courseItem.dataset.raceIsOver == "1"){
                this.setRaceOverIcon(raceIcons, defaultVideoIcon, redVideoIcon, bigPlayIcon);
            }
        });

    }

    setRedVideoIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon){
        defaultVideoIcon.style.display = "none";
        bigPlayIcon.style.display = "none";
        redVideoIcon.style.display = "inline-block";
    }

    setDefaultVideoIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon){
        defaultVideoIcon.style.display = "block";
        bigPlayIcon.style.display = "none";
        redVideoIcon.style.display = "none";
    }

    setRedPlayIcon(defaultVideoIcon, redVideoIcon, bigPlayIcon){
        defaultVideoIcon.style.display = "none";
        redVideoIcon.style.display = "none";

        bigPlayIcon.style.display = "inline-block";
        bigPlayIcon.style.width = "32px";
        bigPlayIcon.style.height = "32px";
    }

    setRaceOverIcon(iconsWrap, defaultVideoIcon, redVideoIcon, bigPlayIcon){
        iconsWrap.style.display = "none";
        defaultVideoIcon.style.display = "none";
        redVideoIcon.style.display = "none";
        bigPlayIcon.style.display = "none";
    }

    isLoggedIn(){
        let status;
        const bookmakerInfoString = window.localStorage.getItem("userAccountsInfo");

        if(!bookmakerInfoString) return status = false;

        const bookmakersInfo = JSON.parse(bookmakerInfoString);

        for (let bookmaker in bookmakersInfo) {
            if(bookmakersInfo[bookmaker]['isLoggedIn'] == true){
                return status = true;
            }
        }

        return status = false;
    }

    isQualified(raceId){
        let status;
        const bet2viewString = window.localStorage.getItem("bet2view");

        if(bet2viewString === null ) return status = false;

        const bet2view = JSON.parse(bet2viewString);

        if(!bet2view.hasOwnProperty("qualification")) return status = false;

        for (let race of bet2view.qualification) {
            if(race['race-id'] == raceId){
                return status = true;
            }
        }

        return status = false;
    }

    isLivestreamActive(date){
      let numMinutesBeforeStart = 3;
      let raceTs = new Date(date).getTime();
      let nowTs = Date.now();
      return raceTs - nowTs < numMinutesBeforeStart * 60 * 1000;
    }
    //here
}



// WEBPACK FOOTER //
// ./lib/js/modules/betAndLoginToWatchCourseList.js